import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom';
import {images } from '../../assets';

function Footer() {
  const date=new Date();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // setShowMenu(false); // Close the menu after clicking a link
  };

  return (
    <footer>
      <div className='footer-container' >
        <div className='footer-sec1'>
        <div className='impactlogo'>
          <Link to='/' onClick={scrollToTop} ><img  src={images.appIcon} alt='app-icon' /></Link>
        
        </div>
        <div className='playbutton'>
          <Link to="https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en"><img src={images.googlePlayStore} alt='play-store' /></Link>
          <Link to="https://apps.apple.com/in/app/impact-fitness-charity/id1143265464"><img src={images.appStore} alt='apple-store' /></Link>
        </div>
        </div>
      <div className='content' >
        <div className='footer-sec2'>
        <ul>
          <div className='headings' >Company</div>
          <Link to='/about' target='_blank' ><li><div className='footerPage'>About</div></li></Link>
          <Link to='/careers' target='_blank' ><li><div className='footerPage'>Join Us</div></li></Link>
          {/* <Link to='#' target='_blank' ><li><div className='footerPage'>Blog</div></li></Link> */}
          <a href='privacypolicy.html' target='_blank' ><li><div className='footerPage'>Privacy Policy</div></li></a>
          <a href='terms.html' target='_blank'><li><div className='footerPage'>Terms and Conditions</div> </li> </a>
          <a href='guideline.html' target='_blank' ><li><div className='footerPage'>Guidelines</div></li></a>
          <a href='pricingpolicy.html' target='_blank' ><li><div className='footerPage'>Pricing Policy</div></li></a>
          <a href='cancellationpolicy.html' target='_blank' ><li><div className='footerPage'>Cancellation</div></li></a>
        </ul>
      </div>
      <div className='footer-sec3'>
        <ul>
          <Link to='/offerings' onClick={scrollToTop} ><div className='headings' >Offerings</div></Link>
          <Link to='/theImpactLeague' onClick={scrollToTop} ><li><div className='footerPage'>The Impact League</div></li></Link>
          <Link to='/causeBranding' onClick={scrollToTop} ><li><div className='footerPage'>Cause Branding</div></li></Link>
          <Link to='/marketingBrands' onClick={scrollToTop} ><li><div className='footerPage'>Marketing Brands</div></li></Link>
        </ul>
      </div>
      </div>
      <div className='footer-sec4'>
        <ul>
          <div className='headings' >Stay Connected</div>
          <div className='impactEmail'>contact@impactrun.com</div>
          <div className='socialmedia'>
          <Link to="https://www.instagram.com/impact.app/?hl=en" target="_blank"><img className='socialmedialogo' src={images.instagram} alt='instagram'/></Link>
          <Link to="https://www.facebook.com/impactapp01/" target="_blank"><img className='socialmedialogo' src={images.facebook} alt='faccebook'/></Link>
          <Link to="https://twitter.com/Impact_App_" target="_blank"><img className='socialmedialogo' src={images.twitter} alt='twitter'/></Link>
          <Link to="https://www.linkedin.com/company/impact-employee-engagement" target="_blank"><img className='socialmedialogo' src={images.linkedin} alt='linkedin'/></Link>
          </div>
        </ul>
        </div>
      </div>
      <div className='tabletContent'>
      <div className='footer-sec2'>
        <ul>
          <div className='headings' >Company</div>
          <Link to='/about' target='_blank' ><li><div className='footerPage'>About</div></li></Link>
          <Link to='/careers' target='_blank' ><li><div className='footerPage'>Join Us</div></li></Link>
          {/* <Link to='#' target='_blank' ><li><div className='footerPage'>Blog</div></li></Link> */}
          <a href='privacypolicy.html' target='_blank' ><li><div className='footerPage'>Privacy Policy</div></li></a>
          <a href='terms.html' target='_blank'><li><div className='footerPage'>Terms and Conditions</div> </li> </a>
          <a href='guideline.html' target='_blank' ><li><div className='footerPage'>Guidelines</div></li></a>
          <a href='pricingpolicy.html' target='_blank' ><li><div className='footerPage'>Pricing Policy</div></li></a>
          <a href='cancellationpolicy.html' target='_blank' ><li><div className='footerPage'>Cancellation</div></li></a>
        </ul>
      </div>
      <div className='footer-sec3'>
        <ul>
          <Link to='/offerings' onClick={scrollToTop} ><div className='headings' >Offerings</div></Link>
          <Link to='/theImpactLeague' onClick={scrollToTop} ><li><div className='footerPage'>The Impact League</div></li></Link>
          <Link to='/causeBranding' onClick={scrollToTop} ><li><div className='footerPage'>Cause Branding</div></li></Link>
          <Link to='/marketingBrands' onClick={scrollToTop} ><li><div className='footerPage'>Marketing Brands</div></li></Link>
        </ul>
      </div>
      <div className='footer-sec4-tablet'>
        <ul>
          <div className='headings' >Stay Connected</div>
          <div className='impactEmail'>contact@impactrun.com</div>
          <div className='socialmedia'>
          <Link to="https://www.instagram.com/impact.app/?hl=en" target="_blank"><img className='socialmedialogo' src={images.instagram} alt='instagram'/></Link>
          <Link to="https://www.facebook.com/impactapp01/" target="_blank"><img className='socialmedialogo' src={images.facebook} alt='faccebook'/></Link>
          <Link to="https://twitter.com/Impact_App_" target="_blank"><img className='socialmedialogo' src={images.twitter} alt='twitter'/></Link>
          <Link to="https://www.linkedin.com/company/impact-employee-engagement" target="_blank"><img className='socialmedialogo' src={images.linkedin} alt='linkedin'/></Link>
          </div>
        </ul>
        </div>

      </div>
      
      
      <div className='footerlast' >
        <div> &#169; {date.getFullYear()} Green Freedom Pvt Ltd. All rights reserved.</div>
      </div>
      
    </footer>
  )
}

export default Footer
